// extracted by mini-css-extract-plugin
export var container = "_9k-0";
export var error = "_9k-9";
export var label = "_9k-5";
export var light = "_9k-6";
export var md = "_9k-3";
export var sm = "_9k-2";
export var thin = "_9k-8";
export var thinBold = "_9k-7";
export var vertical = "_9k-4";
export var xs = "_9k-1";